// Removes spaces between numbers
function processFormatNumber(numberToFormat) {
    return numberToFormat.replace(/\s/g,'')
}
    
function formatMillier( nombre ) {
    return new Intl.NumberFormat().format( nombre );
} 

export default {
    currency(bu) {
        if (bu === 'NORRUS') {
            return '₽'
        } else if (bu === 'NORPOL') {
            return 'zł'
        } else if(bu === 'NORROU') {
            return 'RON'
        } else if(bu === 'NORARG') {
            return 'ARS'
        } else {
            return '€'
        }
    },
    getEuroValue(currencies, bu, currencyValue) {
        currencyValue = processFormatNumber(currencyValue)
        let result = ''

        if(currencies != null && currencyValue != null) {
            if (bu === 'NORRUS') {
                result = Math.round(currencyValue * 100 / currencies.RUB) / 100
            } else if (bu === 'NORPOL') {
                result = Math.round(currencyValue * 100 / currencies.PLN) / 100
            } else if(bu === 'NORROU') {
                result = Math.round(currencyValue * 100 / currencies.RON) / 100
            } else if(bu === 'NORARG') {
                result = Math.round(currencyValue * 100 / currencies.ARS) / 100
            } else {
                return result
            }
        }else{
            return result
        }

        return formatMillier(result)
    },
}